import { IoMdPerson } from "react-icons/io";
import { FaFilePrescription } from "react-icons/fa";
import { MdAccessTimeFilled } from "react-icons/md";
import { IoIosDocument } from "react-icons/io";
import { ImCross } from "react-icons/im";
import { IoCall, IoLogOut } from "react-icons/io5";
import { BsPersonXFill } from "react-icons/bs";
import { VscDebugRestart } from "react-icons/vsc";
import { FaEdit } from "react-icons/fa";
import { RiChatFollowUpLine } from "react-icons/ri";

// const getBaseAndToken = () => {
//   const hostname = window.location.hostname;
//   const config = {
//     localhost: {
//       BASE_URL: process.env.REACT_APP_BASE_URL,
//       ADMIN_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
//       PATIENT_ROLE: process.env.REACT_APP_PATIENT_ROLE,
//     },
//     "dev.cufront.com": {
//       BASE_URL: process.env.REACT_APP_BASE_URL,
//       ADMIN_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
//       PATIENT_ROLE: process.env.REACT_APP_PATIENT_ROLE,
//     },

//     default: {
//       BASE_URL: process.env.REACT_APP_BASE_URL,
//       ADMIN_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
//       PATIENT_ROLE: process.env.REACT_APP_PATIENT_ROLE,
//     },
//   };

//   const { BASE_URL, ADMIN_TOKEN, PATIENT_ROLE } =
//     config[hostname] || config["default"];

//   return { BASE_URL, ADMIN_TOKEN, PATIENT_ROLE };
// };

// const { BASE_URL, ADMIN_TOKEN, PATIENT_ROLE } = getBaseAndToken();

// export { BASE_URL, ADMIN_TOKEN, PATIENT_ROLE };

// export const BHARATHEALPOINT_LOGO = `https://testapi.bharathealpoint.com/assets/db77a9f5-20ed-46f7-a163-06294b54a409`;
// export const BHARATHEALPOINT_LOGO_WITH_DES = `https://testapi.bharathealpoint.com/assets/af8eae24-25ec-48de-83a6-b7e663a6701c`;
// export const NODE_API_URL = "https://dev-chat.cufront.com/api"
export const NODE_API_URL = "https://dev-chat.cufront.com/api";

export const eventIcons = {
  startConsultation: (
    <FaFilePrescription size={"1.2em"} className="text-[#57D08B]" />
  ),
  endConsultation: <IoLogOut size="21" color="red" />,
  viewProfile: <IoMdPerson size={"1.3em"} className="text-[#9644FF]" />,
  reshedule: <MdAccessTimeFilled size={"1.3em"} className="text-[#3592FF]" />,
  invoice: <IoIosDocument size={"1.3em"} className="text-[#FF653B]" />,
  decline: <ImCross size={"1em"} className="text-[#F53C59] mt-1" />,
  call: <IoCall size={"1.2em"} className="text-[#0042C3]" />,
  noShow: <BsPersonXFill size={"1.3em"} className="text-[#F5CE03]" />,
  restart: <VscDebugRestart size={"1.3em"} className="text-[#57D08B]" />,
  edit: <FaEdit size={"1.2em"} className="text-[#0042C3]" />,
  preConsultation: <RiChatFollowUpLine size={"1.2em"} color="red" />,
  preConsultationDone: <RiChatFollowUpLine size={"1.2em"} color="green" />,
};
